
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// GET medical history (for pre-fill)
// export const getPatientMedicalHistory = async (patientId, appointmentId) => {

//   try {
//     const response = await axios.get(
//       `${API_BASE_URL}/patients/${patientId}/medical-history`,
//       {

//         headers: {
//           "Authorization": `Bearer ${localStorage.getItem("token")}`
//         }
//       }
//     );
//     return response.data;
//   } catch (error) {
//     console.error(
//       "Error fetching patient medical history:",
//       error.response?.data || error.message
//     );
//     throw error;
//   }
// };

export const getPatientMedicalHistory = async (patientId, appointmentId) => {
  if (!appointmentId) {
    throw new Error("appointment_id is required");
  }

  const response = await axios.get(
    `${API_BASE_URL}/patients/${patientId}/medical-history`,
    {
      params: { appointment_id: appointmentId },
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  );

  return response.data;
};


// GET patient details
export const getPatientDetails = async (patientId) => {
  try {
    // First try to get patient details from the medical history endpoint
    const response = await axios.get(
      `${API_BASE_URL}/patients/${patientId}/medical-history`,
      {
        headers: {
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
      }
    );

    // If the response contains patient details, return them
    if (response.data && response.data.patient) {
      return response.data.patient;
    }

    // If no patient details found, return a default object with the ID
    return {
      id: patientId,
      name: `Patient ${patientId}`
    };
  } catch (error) {
    console.error(
      "Error fetching patient details:",
      error.response?.data || error.message
    );
    // Return a default object with the ID if the request fails
    return {
      id: patientId,
      name: `Patient ${patientId}`
    };
  }
};

// POST medical history (save / update)
export const savePatientMedicalHistory = async (patientId, data) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/patients/${patientId}/medical-history`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error saving patient medical history:",
      error.response?.data || error.message
    );
    throw error;
  }
};


